import MatchingEventBanner from './MatchingEventBanner'
export default MatchingEventBanner
